import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

const SettingButton = (props) => {
  return (
    <IconButton className="w-40 h-40" onClick={() => null} size="large">
      {props.children}
    </IconButton>
  );
};
SettingButton.defaultProps = {
  children: <FuseSvgIcon>material-outline:settings</FuseSvgIcon>,
};

export default SettingButton;
